module.exports = __webpack_public_path__ + "media/images/display/complete-564e88161cad35239e695b7deb85cdb8.svg";